import countriesList from '../../../assets/countries.json';
import compaignTypes from '../../../assets/campaignTypes.json';
import currencies from '../../../assets/currencies.json';
// import { PVPartnerAPI } from './entityFieldModels';

export default {
  Offer: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Header',
          model: 'firstHeader',
          required: true,
        },
        {
          label: 'Unique name (used as a short ID)',
          model: 'uniqueName',
          required: true,
        },
        {
          label: 'Body',
          model: 'secondHeader',
          required: true,
          htmlText: true,
        },
        {
          label: 'Project id',
          model: 'projectId',
          popupInfo: `<div>Project id of the Offer</div>
            <div>This is used in CRM, ERP and support systems</div>`
        },
        {
          label: 'Campaign start',
          model: 'localCampaignStartAt',
          date: true,
          required: true,
        },
        {
          label: 'Campaign end',
          model: 'localCampaignEndAt',
          date: true,
          required: true,
        },
      ],
    },
    dateTimeGroup: {
      title: 'Date and Time',
      columns: 3,
      fields: [
        {
          label: 'Use date from and to',
          model: 'useExpiresAt',
          checkbox: true,
        },
        {
          label: 'Avaliable from',
          model: 'localStartsAt',
          date: true,
        },
        {
          label: 'Avaliable to',
          model: 'localExpiresAt',
          date: true,
        },
      ],
    },
    advancedGroup: {
      title: 'Advanced',
      columns: 3,
      fields: [
        {
          label: 'Quick text',
          model: 'quickText',
          required: true,
        },
        {
          label: 'Columns wide, when at it\'s parent',
          model: 'columns',
          inputType: 'select',
          selectOptions: [1,2,3],
          required: true,
        },
        {
          label: 'Order (descending)',
          model: 'order',
        },
        {
          label: 'Ability to share',
          model: 'share',
          checkbox: true,
        },
        {
          label: 'Unique icon',
          model: 'uniqueIcon',
          checkbox: true,
        },
        {
          label: 'Clickable',
          model: 'clickable',
          checkbox: true,
        },
        {
          label: 'Hide text-box at collection page',
          model: 'hideTextBox',
          checkbox: true,
        },
        {
          label: 'Button title',
          model: 'linkButtonTitle',
          required: true,
        },
        /*{
          label: 'Total amount of winners (old)',
          model: 'winnersTotal',
        },*/
        {
          label: 'Expiration, seconds until the offer will expire',
          model: 'expiration',
        },
        {
          label: 'Icon Redirect',
          model: 'iconRedirect',
          checkbox: true,
        }
      ],
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: [
        {
          label: 'Filenames',
          model: 'filenames',
          required: true,
          inputType: 'textarea',
          editOnly: true,
        },
        {
          label: 'Thumbnail Filenames',
          model: 'thumbnailFilenames',
          required: true,
          inputType: 'textarea',
          editOnly: true,
        },
        /*{
          editOnly: true,
          label: 'Media',
          model: 'media',
          entity: 'Offer',
          mediaType: 'Picture',
          aspectWidth: 1,
          aspectHeight: 1,
          column2AspectWidth: 420,
          column2AspectHeight: 340,
          upload: true,
        },
        {
          label: 'Thumbnail',
          model: 'fe_thumbnail',
          entity: 'Offer',
          mediaType: 'Thumbnail',
          upload: true,
        },
        {
          label: 'Icon',
          model: 'fe_icon',
          entity: 'Offer',
          mediaType: 'Icon',
          aspectWidth: NaN,
          aspectHeight: NaN,
          upload: true,
        }*/
      ],
    },
    pointsGroup: {
      title: 'Points',
      columns: 3,
      fields: [
        /*{
          label: 'Count Visited?',
          model: 'pointsVisitedCounter',
          checkbox: true,
        },
        {
          label: 'Show checkmark?',
          model: 'pointsVisitedIcon',
          checkbox: true,
        },*/
        {
          label: 'Points for viewing',
          model: 'pointsVisited',
        },
      ]
    },
    signupGroup: {
      title: 'Signup',
      columns: 2,
      fields: [
        {
          label: 'Third Party Crm Name',
          model: 'thirdPartyCrmName',
        },
        {
          label: 'Login requirement for CTA',
          model: 'mustLogin',
          checkbox: true,
        },
      ]
    },
    bannerGroup: {
      title: 'Banner',
      columns: 3,
      fields: [
        {
          label: 'Sub-Header inside the banner, on Collection page',
          model: 'bannerSubHeader',
        },
        {
          label: 'Header inside the banner, on Collection page',
          model: 'bannerHeader',
        },
        {
          label: 'Button text inside the banner, on Collection page',
          model: 'bannerButtonText',
        },
      ]
    },
    surveyGroup: {
      title: 'Survey',
      fields: [
        {
          label: 'Survey (input is [{}] look at offer model',
          model: 'survey',
          inputType: 'textarea',
        },
      ],
    },
    linkGroup: {
      title: 'Links Out',
      fields: [
        {
          groupHeader: 'Direct',
        },
        {
          label: 'Direct link',
          model: 'directLink',
          fieldDescription: 'Redirect to an url directly, at the collection page (example se.enginio.io)',
        },
        {
          groupHeader: 'External',
        },
        {
          label: 'External link (ex se.enginio.io)',
          model: 'externalLink',
          fieldDescription: 'Redirect to another url at CTA button click (not a new tab if it is enginio.io)',
        },
        {
          line: true,
        },
        {
          groupHeader: 'Links Gallery',
        },
        {
          label: 'Links gallery',
          model: 'linksGallery',
          linksGallery: true,
        },
      ],
    },
    claimGroup: {
      title: 'Claim your ...',
      columns: 3,
      fields: [
        {
          label: 'Recurring activation, from and to',
          model: 'useRecurring',
          checkbox: true,
        },
        {
          label: 'How many can win per day?',
          model: 'recurringTotal',
          required: true,
        },
        {
          label: 'Avaliable from (hours 1-23)',
          model: 'recurringStartsAt',
          required: true,
        },
        {
          label: 'Avaliable to (hours 1-23)',
          model: 'recurringExpiresAt',
          required: true,
        },
        {
          label: 'The prize, in its definite form (the icecream)',
          model: 'thePrize',
          required: true,
        },
        {
          label: 'Ask the winner for adress',
          model: 'winnerAdress',
          checkbox: true,
        },
        {
          label: 'recurringWinVideo, filename',
          model: 'recurringWinVideo',
        },
        {
          label: 'recurringLooseVideo, filename',
          model: 'recurringLooseVideo',
        },
      ],
    },
    clearonGroup: {
      title: 'ClearOn',
      columns: 3,
      fields: [
        {
          label: 'Clearon Code (replaces "External link")',
          model: 'internalLink',
          checkbox: true,
        },
        {
          label: 'Clearon account (replaces brand clearon account)',
          model: 'clearonAccount',
          required: true,
        },
        {
          label: 'Clearon password',
          model: 'clearonPassword',
          required: true,
        },
        {
          label: 'Clearon Id (campaign Id)',
          model: 'clearonId',
          required: true,
        },
        {
          label: 'Clearon EAN Id (campaign Id)',
          model: 'clearonEanId',
          required: true,
        },
      ],
    },
    appGroup: {
      title: 'App Download',
      columns: 2,
      fields: [
        {
          label: 'Appstore länk',
          model: 'appstore',
          fieldDescription: 'Appstore image at collection page, insert URL',
        },
        {
          label: 'Google play länk',
          model: 'gPlay',
          fieldDescription: 'Google play image at collection page, insert URL',
        },
      ],
    },
    iframeGroup: {
      title: 'Iframe and Video Host',
      columns: 2,
      fields: [
        {
          label: 'Iframe Website, replaces the offer view',
          model: 'iframeWebsite',
        },
        {
          label: 'Host',
          model: 'iframeMediaHost',
          inputType: 'select',
          selectOptions: ['Vimeo'], //, 'Youtube', 'Twitch',
        },
        {
          label: 'Video id (id of the video in the iframe)',
          model: 'iframeMediaId',
          }
      ],
    },
    donationGroup: {
      title: 'Donations and Exclusivity',
      columns: 3,
      fields: [
        {
          label: 'Exclusivity, in relation to other offers',
          model: 'exclusivity',
          required: true,
        },
        {
          label: 'Actual value', // , till donations
          model: 'value',
          required: true,
        },
      ],
    },
    emailGroup: {
      title: 'CTA',
      fields: [
        {
          label: 'ctaEmail, send an email if you win',
          model: 'ctaEmail',
          checkbox: true,
        },
        {
          label: 'ctaEmailTemplate, email template (encode user name: {{user.name}} or {{user.last_name}} or {{code}})',
          model: 'ctaEmailTemplate',
          inputType: 'textarea',
        },
      ],
    },
    subscriberGroup: {
      title: 'Notifications on completion',
      fields: [
        {
          label: 'Send auto-generated emails when user completes CTA',
          model: 'ctaSubcribeToEvents',
          checkbox: true,
        },
        {
          label: 'Comma-separated list of recipient emails (any email adress, even external)',
          model: 'ctaSubscribeEventsRecipients',
          inputType: 'textarea',
        },
      ],
    },
    termsGroup: {
      title: 'Terms',
      columns: 2,
      fields: [
        {
          label: 'Terms',
          model: 'termsText',
          htmlText: true,
          fieldDescription: 'If there are terms, an icon will be shown in the activation to open a modal with this in it',
        },
        {
          label: 'Merchandise terms',
          model: 'termsMerchandise',
          htmlText: true,
          fieldDescription: 'If there is such a text, it will be next to the "accept further merchandise" checkbox',
        },
        {
          label: 'Merchandise checkbox default',
          model: 'termsMerchandiseDefault',
          checkbox: true,
          fieldDescription: 'The default value of the checkbox',
        },
        {
          label: 'Must Accept terms',
          model: 'termsMustAccept',
          checkbox: true,
          fieldDescription: 'The user must accept the terms in order to use the activation',
        }
      ],
    },
    jwtGroup: {
      title: 'Lock',
      columns: 2,
      fields: [
        {
          label: 'Jwt Lock',
          model: 'jwtLock',
          checkbox: true,
          fieldDescription: 'If there is a lock, the user must first unlock it by some means (see /unlock-offer in backend docs)',
        },
        {
          label: 'Jwt lock explanation',
          model: 'jwtLockExplanation',
          htmlText: true,
          fieldDescription: 'If there are an explanation, a modal will appear if it is locked',
        },
        {
          label: 'Jwt lock button text',
          model: 'JwtLockButtonText',
          fieldDescription: 'This text replaces "Back" on the button',
        },
        {
          label: 'Jwt lock button url',
          model: 'JwtLockButtonUrl',
          fieldDescription: 'This url replaces "goto-Parent" on the button',
        },
      ]
    },
    scheduling: {
      title: 'Scheduling',
      columns: 2,
      fields: [
        {
          label: 'Automatically publish on',
          model: 'localScheduledPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically unpublish on',
          model: 'localScheduledUnPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically Soft publish on',
          model: 'localScheduledSoftPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically Soft unpublish on',
          model: 'localScheduledSoftUnPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically archive on',
          model: 'localScheduledArchiveAt',
          date: true,
          required: true,
        },
      ]
    }
  },

  Hyperlink: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Base Url',
          model: 'url',
          required: true,
        }
      ],
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: [],
    },
  },

  Goodiebag: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Unique name (used as a short ID)',
          model: 'uniqueName',
          required: true,
        },
        {
          label: 'Info',
          model: 'info',
          required: true,
          htmlText: true,
        },
        {
          label: 'Project id',
          model: 'projectId',
          popupInfo: `<div>Project id of the Collection</div>
            <div>This is used in CRM, ERP and support systems</div>`
        },
        {
          label: 'Campaign start',
          model: 'localCampaignStartAt',
          date: true,
          required: true,
        },
        {
          label: 'Campaign end',
          model: 'localCampaignEndAt',
          date: true,
          required: true,
        },
      ],
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: [
        {
          label: 'Filenames',
          model: 'filenames',
          required: true,
          inputType: 'textarea',
          editOnly: true,
        },
        {
          label: 'Thumbnail Filenames',
          model: 'thumbnailFilenames',
          required: true,
          inputType: 'textarea',
          editOnly: true,
        },
        /*{
          label: 'Media',
          model: 'media',
          entity: 'Goodiebag',
          mediaType: 'Picture',
          aspectWidth: 1400,
          aspectHeight: 350,
          nemoAspectWidth: NaN,
          nemoAspectHeight: NaN,
          upload: true,
        },
        {
          label: 'Icon',
          model: 'fe_icon',
          entity: 'Goodiebag',
          mediaType: 'Icon',
          aspectWidth: NaN,
          aspectHeight: NaN,
          upload: true,
        },*/
      ]
    },
    designGroup: {
      title: 'Design & Behaviour',
      columns: 3,
      fields: [
        {
          label: 'Order (descending)',
          model: 'order',
        },
        {
          label: 'Theme',
          model: 'theme',
          inputType: 'select',
          selectOptions: ['iris','nemo'],
          required: true,
        },
        {
          label: 'Columns wide, when at it\'s parent',
          model: 'columns',
          inputType: 'select',
          selectOptions: [1,2,3],
          required: true,
        },
        {
          label: 'Direct Link, take the consumer to an url when at it\'s parent',
          model: 'directLink',
        },
        {
          label: 'Banner, when at it\'s parent',
          model: 'banner',
          checkbox: true,
        },
        {
          label: 'Banner activations, both ordinary children and these specific children will appear in the banner',
          model: 'bannerOffers',
          inputType: 'textarea',
        },
        {
          label: 'Hide Subtitle, when at it\'s parent',
          model: 'hideSubtitle',
          checkbox: true,
        },
        /*{
          label: 'Donations',
          model: 'donations',
          checkbox: true,
        },*/
      ]
    },
    signupGroup: {
      title: 'Signup',
      columns: 2,
      fields: [
        {
          label: 'Third Party Crm Name',
          model: 'thirdPartyCrmName',
        },
      ]
    },
    pointsGroup: {
      title: 'Points',
      columns: 3,
      fields: [
        /*{
          label: 'Count Visited?',
          model: 'pointsVisitedCounter',
          checkbox: true,
        },
        {
          label: 'Show checkmark?',
          model: 'pointsVisitedIcon',
          checkbox: true,
        },*/
        {
          label: 'Points for viewing',
          model: 'pointsVisited',
        },
      ]
    },
    jwtGroup: {
      title: 'Lock',
      columns: 2,
      fields: [
        {
          label: 'Jwt Lock',
          model: 'jwtLock',
          checkbox: true,
          fieldDescription: 'If there is a lock, the user must first unlock it by some means (see /unlock-goodiebag in backend docs)',
        },
        {
          label: 'Jwt lock explanation',
          model: 'jwtLockExplanation',
          htmlText: true,
          fieldDescription: 'If there are an explanation, a modal will appear if it is locked',
        },
        {
          label: 'Jwt lock button text',
          model: 'JwtLockButtonText',
          fieldDescription: 'This text replaces "Back" on the button',
        },
        {
          label: 'Jwt lock button url',
          model: 'JwtLockButtonUrl',
          fieldDescription: 'This url replaces "goto-Parent" on the button',
        },
      ]
    },
    scheduling: {
      title: 'Scheduling',
      columns: 2,
      fields: [
        {
          label: 'Automatically publish on',
          model: 'localScheduledPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically unpublish on',
          model: 'localScheduledUnPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically Soft publish on',
          model: 'localScheduledSoftPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically Soft unpublish on',
          model: 'localScheduledSoftUnPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically archive on',
          model: 'localScheduledArchiveAt',
          date: true,
          required: true,
        },
      ]
    }
  },

  Company: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Unique name (used as a short ID)',
          model: 'uniqueName',
          required: true,
        },
        {
          label: 'Info',
          model: 'info',
          required: true,
          inputType: 'textarea',
        },
        /*{
          label: 'RP id',
          model: 'rpId',
          required: true,
        },
        {
          label: 'Clearon account, används på alla erbjudanden',
          model: 'clearonAccount',
          required: true,
        },
        {
          label: 'Dashboard (dp-insights)',
          model: 'dashboard',
        },
        {
          label: 'pixel (fb-pixel)',
          model: 'pixel',
        },*/
        {
          label: 'Customer Id',
          model: 'customerId',
          popupInfo: `<div>Customer id of the Company</div>
            <div>This is used in CRM, ERP and support systems</div>`
        },
        {
          label: 'Iframe Dashboard, url to dashboard',
          model: 'iframeDashboard',
        },
        {
          label: 'Clearon password',
          model: 'clearonPassword',
          required: true,
        },
        {
          label: 'Whitelist domains',
          model: 'whitelist',
          required: true,
        },
        {
          label: 'Jwt key',
          model: 'jwtKey',
          required: true,
        },
        {
          label: 'Closest Stores link',
          model: 'closestStores',
        },
      ],
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: [
        /*{
          editOnly: true,
          label: 'Media',
          model: 'media',
          entity: 'Company',
          mediaType: 'Picture',
          aspectWidth: 1400,
          aspectHeight: 350,
          upload: true,
        },
        {
          editOnly: true,
          label: 'Icon',
          model: 'fe_thumbnail',
          entity: 'Company',
          mediaType: 'Thumbnail',
          aspectWidth: NaN,
          aspectHeight: NaN,
          upload: true,
        },
        {
          editOnly: true,
          label: 'Icon',
          model: 'fe_icon',
          entity: 'Company',
          mediaType: 'Icon',
          aspectWidth: NaN,
          aspectHeight: NaN,
          upload: true,
        },*/
      ]
    },
    designGroup: {
      title: 'Design & Behaviour',
      columns: 3,
      fields: [
        {
          label: 'Custom Url',
          model: 'customUrl',
        },
        {
          label: 'Order (descending)',
          model: 'order',
        },
        {
          label: 'Replace Brand, the brand page will not be shown anymore, this collection will be shown instead',
          model: 'replaceCompany',
        },
        {
          label: 'Club',
          model: 'club',
          checkbox: true,
          required: true,
        },
        {
          label: 'Info about the club, on the club profile page',
          model: 'clubAbout',
          htmlText: true,
          required: true,
        },
        {
          label: 'New Product Button Text, at club profile myproducts page',
          model: 'newProductButtonText',
        },
        {
          label: 'New Product Button Url, at club profile myproducts page',
          model: 'newProductButtonUrl',
        },
        {
          label: 'Theme',
          model: 'theme',
          inputType: 'select',
          selectOptions: ['iris','nemo'],
          required: true,
        },
        // The idea is that 900 is almost black, 100 is almost white
        {
          label: 'Brand color 400',
          model: 'brand400Color',
          required: true,
        },
        {
          label: 'Brand color 900',
          model: 'brand900Color',
          required: true,
        },
        {
          label: 'Brand button color',
          model: 'brandButtonColor',
          required: true,
        },
        {
          label: 'Bold font (overwrite Enginio font)',
          model: 'fontBold',
          inputType: 'select',
          selectOptions: ['', 'NeueFrutigerWorldW05-Bold'],
          required: true,
        },
        {
          label: 'Regular font (overwrite Enginio font)',
          model: 'fontRegular',
          inputType: 'select',
          selectOptions: ['', 'NeueFrutigerWorldW05-Regular'],
          required: true,
        },
        {
          label: 'Medium font (overwrite Enginio font)',
          model: 'fontMedium',
          inputType: 'select',
          selectOptions: ['', 'NeueFrutigerWorldW05-Medium'],
          required: true,
        },
        {
          label: 'Hide Navigation (everywhere inside this brand)',
          model: 'hideNavigation',
          checkbox: true,
        },
        {
          label: 'Hide Enginio Logo (everywhere inside this brand)',
          model: 'hideEnginioLogo',
          checkbox: true,
        },
        {
          label: 'Disable blurry header image (everywhere inside this brand)',
          model: 'disableBlurryHeaderImage',
          checkbox: true,
        },
        {
          label: 'FAQ url, will be displayed in an iframe',
          model: 'faqUrl',
        },
      ]
    },
    partnerGroup: {
      title: 'Partner settings',
      columns: 2,
      fields: [
        {
          label: 'Hide Participations menu',
          model: 'hideParticipationsMenu',
          checkbox: true,
        },
        {
          label: 'Hide Receipts menu',
          model: 'hideReceiptsMenu',
          checkbox: true,
        }
      ]
    },
    contactGroup: {
      title: 'Contacts',
      columns: 3,
      fields: [
        {
          label: 'Legal name',
          model: 'legalName',
        },
        {
          label: 'Organisational number',
          model: 'orgNumber',
        },
        {
          label: 'Phone Number',
          model: 'phoneNr',
        },
        {
          label: 'Email',
          model: 'email',
        },
        {
          label: 'Postal Address',
          model: 'address',
        },
        {
          label: 'Postal Code',
          model: 'postalCode',
        },
        {
          label: 'City',
          model: 'city',
        },
        {
          label: 'Country',
          model: 'country',
        },
      ]
    },
    signupGroup: {
      title: 'Signup',
      columns: 2,
      fields: [
        {
          label: 'Mandatory login, the login modal will be forced, and cannot be closed',
          model: 'loginMandatory',
          checkbox: true,
        },
        {
          label: 'Login design',
          model: 'loginDesign',
          inputType: 'select',
          selectOptions: ['STANDARD', 'TEXT_BUTTONS'],
        },
        {
          label: 'loginLandingSubheader',
          model: 'loginLandingSubheader',
          htmlText: true,
        },
        {
          label: 'Signup subheader',
          model: 'signupSubheader',
          htmlText: true,
        },
        {
          label: 'Third Party Crm Name',
          model: 'thirdPartyCrmName',
        },
        /*{ Always mandatory now, since you accept both terms and newletter in first checkbox
          label: 'Mandatory enginio subscribe (1st checkbox)',
          model: 'mandatoryEnginioSubscribe',
          checkbox: true,
        },
        {
          label: 'Default Enginio subscribe (1st checkbox), enginio-terms and enginio-newsletter',
          model: 'defaultEnginioSubscribe',
          checkbox: true,
        },*/
        {
          label: 'Mandatory brand subscribe (2nd checkbox) (share to 3rd party crm-system)',
          model: 'mandatoryCompanySubscribe',
          checkbox: true,
        },
        {
          label: 'Default brand subscribe (2nd checkbox)',
          model: 'defaultCompanySubscribe',
          checkbox: true,
        },
        /*{
          label: 'Privacy Url, the url of the 3rd checkbox',
          model: 'privacyUrl',
        },*/
        {
          label: 'Text describing why you need to subscribe (2nd checkbox), first dot (.) will divide the text.',
          model: 'mandatoryCompanySubscribeDescription',
          htmlText: true,
        },
        {
          label: 'Subscribe button text, replace the text on the 2nd checkbox modal button',
          model: 'subscribeButtonText',
        },
      ]
    },
  },

  ParentCompany: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        /*{
          label: 'Unique name (used as a short ID)',
          model: 'uniqueName',
          required: true,
        },*/
        {
          label: 'Clearon password',
          model: 'clearonPassword',
          required: true,
        },
      ],
    },
    signupGroup: {
      title: 'Signup',
      columns: 2,
      fields: [
        {
          label: 'Third Party Crm Name',
          model: 'thirdPartyCrmName',
        },
      ]
    },
    /*uploads: {
      title: 'Uploads',
      columns: 2,
      fields: []
    }*/
  },

  Game: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          validatior: false,
        },
        {
          label: 'Unique Name',
          model: 'uniqueName',
          validatior: false,
        },
        {
          label: 'Project id',
          model: 'projectId',
          popupInfo: `<div>Project id of the Game</div>
            <div>This is used in CRM, ERP and support systems</div>`
        },
        {
          label: 'Must Login',
          model: 'mustLogin',
          checkbox: true,
        },
        {
          label: 'Locked',
          model: 'locked',
          checkbox: true,
        }
      ]
    },

    detailsGroup: {
      title: 'Colors',
      columns: 2,
      fields: [
        {
          label: 'Background Color',
          model: 'bgColor',
          fieldDescription: 'Background Color example: "#000000" or black',
        },
        {
          label: 'Text Color on background 1',
          model: 'textColor',
          fieldDescription: 'Color of the text, in front of the "Background Color"',
        },
        {
          label: 'Desktop Background Color',
          model: 'desktopBgColor',
          fieldDescription: 'Desktop Background Color, behind the "Background Color"',
        },
        {
          label: 'Text Color on background 2',
          model: 'bgTextColor',
          fieldDescription: 'Color of the text, in front of the "Desktop Background Color"',
        },
        {
          label: 'Accent Color',
          model: 'accentColor',
          fieldDescription: 'Accent Color example: "#000000" or black',
        },
      ],
    },

    dateTimeGroup: {
      title: 'Date and Time',
      columns: 3,
      fields: [
        {
          label: 'Use date from and to',
          model: 'useExpiresAt',
          checkbox: true,
        },
        {
          label: 'Avaliable from',
          model: 'localStartsAt',
          date: true,
        },
        {
          label: 'Avaliable to',
          model: 'localExpiresAt',
          date: true,
        },
      ],
    },

    dateTimeReasonGroup: {
      title: 'Date and Time, reasons when you can\'t play',
      columns: 2,
      fields: [
        { groupHeader: 'Use these to insert dynamic date info {{startYear}} {{startMonth}} {{startDate}} {{startDay}} {{startHour}} {{expirationYear}} {{expirationMonth}} {{expirationDate}} {{expirationDay}} {{expirationHour}}' },
        {
          label: 'The game has already ended',
          model: 'reasonAlreadyEnd',
          htmlText: true,
          fieldDescription: '',
        },
        {
          label: 'The game have not started yet',
          model: 'reasonNoStart',
          htmlText: true,
          fieldDescription: '',
        },
      ],
    },

    termsGroup: {
      title: 'Terms',
      columns: 3,
      fields: [
        {
          label: 'Terms',
          model: 'termsText',
          htmlText: true,
          fieldDescription: 'If there are terms, an icon will be shown in the activation to open a modal with this in it',
        },
        {
          label: 'Merchandise terms',
          model: 'termsMerchandise',
          htmlText: true,
          fieldDescription: 'if there is such a text, it will be next to the "accept further merchandise" checkbox',
        },
        {
          label: 'Merchandise checkbox default',
          model: 'termsMerchandiseDefault',
          checkbox: true,
          fieldDescription: 'The default value of the checkbox',
        },
        {
          label: 'Must Accept terms',
          model: 'termsMustAccept',
          checkbox: true,
          fieldDescription: 'The user must accept the terms in order to use the activation',
        }
      ],
    },

    tiebreakerGroup: {
      title: 'Tiebreaker',
      columns: 3,
      fields: [
        {
          label: 'Tiebreak',
          model: 'tiebreak',
          checkbox: true,
          fieldDescription: 'Tiebreak step or not',
        },
        {
          label: 'Tiebreak text, information',
          model: 'tiebreakText',
          htmlText: true,
          fieldDescription: 'Tiebreak text',
        },
        {
          label: 'Tiebreak question, input as {} ',
          model: 'tiebreakQuestion',
          inputType: 'textarea',
        },
        {
          label: 'Tiebreak button text',
          model: 'tiebreakButtonText',
        },
      ],
    },

    competitionGroup: {
      title: 'Competition',
      columns: 3,
      fields: [
        {
          label: 'Onboarding text',
          model: 'landingText',
          htmlText: true,
          fieldDescription: 'Onboarding text, below the image',
        },
        {
          label: 'Go hunt text',
          model: 'gohuntText',
          htmlText: true,
          fieldDescription: 'Information about competition after signup',
        },
        {
          label: 'Go hunt Button Text',
          model: 'gohuntButtonText',
          fieldDescription: 'Example: "Start the hunt"',
        },
        {
          label: 'Hunt header',
          model: 'huntHeader',
          fieldDescription: 'Example: "You have scanned: X/X"',
        },
        {
          label: 'Hunt body',
          model: 'huntBody',
          htmlText: true,
          popupInfo: '<div>Information about the hunt, below the header</div>'
            + '<div>you can use ${username} if you want to incorporate the name</div>',
        },
        {
          label: 'Hunt fun facts header',
          model: 'huntFunfactsHeader',
          fieldDescription: 'Example: "Fun facts"',
        },
        {
          label: 'Hunt fun facts / advertising',
          model: 'huntFunfacts',
          inputType: 'textarea',
          fieldDescription: 'A fun fact or advertising, input like so: ["fact....", "fact2....."]',
        },
        {
          label: 'Winner text',
          model: 'winnerText',
          htmlText: true,
          fieldDescription: 'Text when you are finished with the game'
        },
      ],
    },

    surveyGroup: {
      title: 'Survey',
      columns: 3,
      fields: [
        {
          label: 'Survey Header',
          model: 'surveyHeader',
          inputType: 'textarea',
        },
        {
          label: 'Survey',
          model: 'survey',
          inputType: 'textarea',
          fieldDescription: 'Survey after finished competition like so: [{}]',
        },
        {
          label: 'Survey information',
          model: 'surveyText',
          htmlText: true,
          fieldDescription: 'Information about competition, below the survey',
        },
      ],
    },

    ctaGroup: {
      title: 'CTA',
      columns: 3,
      fields: [
        {
          label: 'Welcome email',
          model: 'welcomeEmail',
          checkbox: true,
          fieldDescription: 'True or false',
        },
        {
          label: 'Welcome email subject',
          model: 'welcomeEmailSubject',
        },
        {
          label: 'Welcome email template',
          model: 'welcomeEmailTemplate',
          inputType: 'textarea',
        },
        {
          label: 'CTA email',
          model: 'ctaEmail',
          checkbox: true,
          fieldDescription: 'True or false',
        },
        {
          label: 'CTA email subject',
          model: 'ctaEmailSubject',
        },
        {
          label: 'CTA email template',
          model: 'ctaEmailTemplate',
          inputType: 'textarea',
        },
        {
          label: 'Reminder email',
          model: 'reminderEmail',
          checkbox: true,
          fieldDescription: 'True or false',
        },
        {
          label: 'Reminder email subject',
          model: 'reminderEmailSubject',
        },
        {
          label: 'Reminder email template',
          model: 'reminderEmailTemplate',
          inputType: 'textarea',
        },
        {
          label: 'Thanks email',
          model: 'thanksEmail',
          checkbox: true,
          fieldDescription: 'True or false',
        },
        {
          label: 'Thanks email subject',
          model: 'thanksEmailSubject',
        },
        {
          label: 'Thanks email template',
          model: 'thanksEmailTemplate',
          inputType: 'textarea',
        },
        {
          label: 'Ask the winner for address',
          model: 'winnerAddress',
          checkbox: true,
        },
        {
          label: 'Claims modal description',
          model: 'claimsDescription',
          htmlText: true,
        },
        {
          label: 'CTA button text',
          model: 'ctaDoneButton',
          fieldDescription: 'When consumer is finished, text on button (default "Back")',
        },
        {
          label: 'CTA button URL',
          model: 'ctaDoneUrl',
          fieldDescription: 'When consumer is finished, URL (default back to brand page)',
        },
      ],
    },
    signupGroup: {
      title: 'Signup',
      columns: 2,
      fields: [
        {
          label: 'Third Party Crm Name',
          model: 'thirdPartyCrmName',
        },
      ]
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: []
    }
  },

  /*
  QrHuntGame: {},
  LoyaltyShopGame: {},
  SpinGame: {},
  */

  PVCompany: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Info',
          model: 'info',
          inputType: 'textarea',
          required: true,
        },
      ],
    },
    thirdPartyGroup: {
      title: 'Third party',
      columns: 2,
      fields: [
        {
          label: 'Bazaarvoice Key',
          model: 'bazaarvoiceKey',
        },
        {
          label: 'Bazaarvoice Encoding Key',
          model: 'bazaarvoiceEncodingKey',
        },
        {
          label: 'Testfreaks Key',
          model: 'testfreaksKey',
        },
        {
          label: 'Testfreaks Client Id',
          model: 'fraudReceiptFlagLimit',
        },
        {
          label: 'Feefo key',
          model: 'feefoKey',
        },
        {
          label: 'Feefo Client Id',
          model: 'feefoClientId',
        },
      ],
    },
    fraudProtectionGroup: {
      title: 'Fraud Protection',
      columns: 2,
      fields: [
        {
          label: 'Receipt flag limit',
          model: 'fraudReceiptFlagLimit',
          required: true,
          popupInfo: '<div>If an activation has a PV step, then we will automatically flag receipts, after the user have scanned a receipt:</div><br/>'
            + '<div>If the limit is X, then you can register X receipt(s) automatically, (X+1)th one will be flagged</div><br/>'
            + '<div>If the limit is 0, then every receipt will be flagged, so that it can be manually checked every time</div>',
        },
      ],
    },
  },

  PVCampaign: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Info',
          model: 'info',
          inputType: 'textarea',
          required: true,
        },
        {
          label: 'CSM Email address, get info about the campaign',
          model: 'csmEmail',
          required: true,
        },
        {
          label: 'Campaign type',
          model: 'campaignType',
          inputType: 'select',
          selectOptions: ['TRIAL', 'BUY_AND_GET', 'BUY_AND_CASHBACK', 'BUY_AND_REVIEW'],
          popupInfo: '<div>This will give you some tips on what settings you should use</div>'
        },
        {
          label: 'Campaign start',
          model: 'localCampaignStartAt',
          date: true,
          required: true,
        },
        {
          label: 'Campaign end',
          model: 'localCampaignEndAt',
          date: true,
          required: true,
        },
      ],
    },
    cashbackGroup: {
      title: 'Cashback info',
      columns: 3,
      fields: [
        {
          label: 'Cashback currency',
          model: 'cashbackCurrency',
          inputType: 'select',
          selectOptions: currencies,
        },
        {
          label: 'Cashback Delay, delay in days before cashback is paid out',
          model: 'cashbackDelay',
        },
        {
          label: 'Cashback Batch amount',
          model: 'cashbackBatchAmount',
          popupInfo: '<div>The amount of cashback that we have transfered to CDI, so far. if you start with 50 and you transfer 50 more, then write 100 here.</div>'
        },
        {
          label: 'Cashback Total amount',
          model: 'cashbackTotalAmount',
          popupInfo: '<div>The amount of cashback, the total amount of cashback that we will give to CDI. if you start with 50 and you transfer 50 more, then write 100 here.</div>'
        },
      ],
    },
    scheduleGroup: {
      title: 'Scheduling',
      columns: 2,
      fields: [
        {
          label: 'Automatically publish on',
          model: 'localScheduledPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically unpublish on',
          model: 'localScheduledUnPublishAt',
          date: true,
          required: true,
        },
      ],
    },
  },

  PVActivation: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
          popupInfo: '<div>Name of the activation</div>'
            + '<ul>'
            + '<li>it\'s visible in PowerBI</li>'
            + '</ul>',
        },
        {
          label: 'Title',
          model: 'title',
          required: true,
          popupInfo: '<div>Title of the activation</div>'
            + '<ul>'
            + '<li>it\'s visible as the page title, in the url bar <b>as a consumer</b></li>'
            + '</ul>',
        },
        {
          label: 'Info',
          model: 'info',
          inputType: 'textarea',
          required: true,
          popupInfo: '<div>More information about the activation</div>'
            + '<ul>'
            + '<li>it\'s only visible here for Admin purposes</li>'
            + '</ul>',
        },
        {
          label: 'Project id',
          model: 'projectId',
          popupInfo: `<div>Project id of the Activation</div>
            <div>This is used in CRM, ERP and support systems</div>`
        },
        {
          label: 'Text color',
          model: 'textColor',
          required: true,
          popupInfo: '<div>This is the text color that appears on mobile in front of the background image</div>'
            + '<div><b>IMPORTANT:</b> Test the contrast together with the background image</div>'
            + '<div>You should not have white text unless you have uploaded a background image</div>'
        },
        {
          label: 'Accent color',
          model: 'accentColor',
          required: true,
          popupInfo: '<div>This is the color of the buttons and other accents, for example the survey inputs</div>'
        },
        {
          label: "Inherit receipt and reg info (insert activation-id)",
          model: "activationReceiptInheritance",
          helper: "",
          popupInfo: '<div>Insert the activation id of the activation you want to inherit receipt and reg info from</div>'
            + '<div>This means that the journey of an activation continues to this one</div>'
        },
        {
          label: 'Recurring',
          model: 'recurring',
          required: true,
          checkbox: true,
          popupInfo: '<div>When the consumer is done with the activation, they can reactivate it</div>'
        },
        {
          label: 'Recurring daily',
          model: 'recurringDaily',
          required: true,
          checkbox: true,
          popupInfo: '<div>When the consumer is done with the activation, they can reactivate it, but only once per day</div>'
        },
        {
          label: 'Recurring limit',
          model: 'recurringLimit',
          required: true,
          popupInfo: '<div>When the consumer is done with the activation, they can reactivate it, but only X amount of times</div>'
        },
        {
          label: 'Timezone',
          model: 'timezone',
          required: true,
        },
        {
          label: 'Market - country',
          model: 'market',
          inputType: 'select',
          selectSettings: {
            optionTitle: 'title',
            optionValue: 'value',
            optionKey: 'key',
        },
          selectOptions: countriesList, // Accessing the countries variable from the VueX state
        },
        {
          label: 'Enginio Offer (insert offer-id)',
          model: 'enginioActivation',
          popupInfo: '<div>Insert the offerId of offer you want to refer back to</div>'
            + '<div>with this setting you will get a "go back to" offer button and image for the consumer</div>'
        },
        {
          label: 'Campaign type',
          model: 'campaignType',
          inputType: 'select',
          selectSettings: {
            optionTitle: 'title',
            optionValue: 'value',
            optionKey: 'key',
          },
          selectOptions: compaignTypes,
          popupInfo: '<div>This will give you some tips on what settings you should use</div>'
        },
        {
          label: 'Campaign start',
          model: 'localCampaignStartAt',
          date: true,
          required: true,
        },
        {
          label: 'Campaign end',
          model: 'localCampaignEndAt',
          date: true,
          required: true,
        },
      ],
    },
    lockGroup: {
      title: 'Lock',
      columns: 2,
      fields: [
        {
          label: 'Lock manager',
          lockManager: true,
          popupInfo: '<div>This means that it is locked for everyone except for the phone nrs in the list</div><br/>',
        },
        {
          label: 'Lock explanation',
          model: 'lockExplanation',
          htmlText: true,
          popupInfo: '<div>This text will be shown in 2 cases:</div><br/>'
            + '<div>1. If the activation is locked with phone nrs and the user is not in that list</div><br/>'
            + '<div>2. If the activation inherits receipt info from another activation and the user have not yet finished the previous activation</div>',
        },
        {
          label: 'Lock button text',
          model: 'lockButtonText',
          fieldDescription: 'This text replaces "Back" on the button',
        },
        {
          label: 'Lock button url',
          model: 'lockButtonUrl',
          fieldDescription: 'This url replaces "goto-Parent" on the button',
        },
        {
          label: 'Test phone nymbers',
          model: 'testPhoneNrs',
          inputType: 'textarea',
          popupInfo: '<div>Insert the phone numbers of the test users</div><br/>'
        },
      ],
    },
    receiptGroup: {
      title: 'Purchase Validation (PV) step',
      columns: 3,
      fields: [
        {
          label: 'Purchase Validation step',
          model: 'receiptStep',
          checkbox: true,
        },
        {
          label: 'Advanced terms search',
          model: 'receiptTermsSearchAdvanced',
          checkbox: true,
          popupInfo: '<div>Allow the receipt item to pickup a word inside the line item scentence</div><br/>'
            + '<div>An example:</div><br/>'
            + '<div>This is written on the receipt: "123-65TUMTV44 (blue) with remote (red)".</div>'
            + '<div>One of the terms is "65TUMTV", with this setting the receipt scanner will pick up the line above.</div>'
            + '<div>"item" will always be the whole scentence "123-65TUMTV44 (blue) with remote (red)".</div>'
            + '<div>"item_match" will be "65TUMTV".</div>'
        },
        {
          label: 'Default to scanned metadata, for line items',
          model: 'receiptTermInWholeString',
          checkbox: true,
          popupInfo: '<div>Default to receipt_metadata.content if PV cannot find the line items</div>',
        },
        {
          label: 'Receipt Terms Multiple',
          model: 'receiptTermsMultiple',
          inputType: 'textarea',
          popupInfo: '<div>The format is: [{ "key": "first", "label": "", "terms": ["first", "second"], "term_minimum_amount": 0, "amount_minimum_estimate": 0, "amount_maximum_estimate": 0, "multiple_rows": false, "mandatory": true }]</div><br/>'
            + '<div>The keys are:</div>'
            + '<ul>'
            + '<li>key: "The key should be the same in registration_terms_multiple.key, so that they can be related.</li>'
            + '<li>label: "The label will be shown above the receipt-edit step.</li>'
            + '<li>terms: "The array of terms that should be matched the line items ["first", "second"]"</li>'
            + '<li>term_minimum_amount: "If there is a minimum cost of the line item needed"</li>'
            + '<li>amount_minimum_estimate: "Estimate the minimum cost of the item (mostly used for cashback)"</li>'
            + '<li>amount_maximum_estimate: "Estimate the maximum cost of the item (mostly used for cashback)"</li>'
            + '<li>multiple_rows: true/false pick several of the same item (if they are on different rows)</li>'
            // + '<li>multiple_amounts: "(not yet tested!)"</li>'
            + '<li>mandatory: true/false </li>'
            + '</ul>',
        },
        {
          label: 'Receipt term Converter',
          model: 'receiptTermConverter',
          inputType: 'textarea',
          popupInfo: '<div>The format is: { "term o": "term o", "term 0": "term o", "term 5": "term S", }</div><br/>'
            + '<div> The above means that "term 0" and "term 5" is incorrect, "term o" and "term S" is correct, this means that "Products" only need to have ["term o","term S"]</div>',
        },
        {
          label: 'Products',
          model: 'products',
          inputType: 'textarea',
          popupInfo: '<div>The format is: ["uniqueProduct1", "uniqueProduct2"]</div><br/>'
            + '<div>This input is quite easy, but it\'s usage is a bit advanced to explain.</div>'
            + '<div>We need to be able to support a few different things:</div>'
            + '<ul>'
            + '<li>"modelNr" => 100SEK cashback</li>'
            + '<li>"imeiNumber" => 200SEK cashback</li>'
            + '<li>line item: "lösgodis" 50SEK => 5SEK cashback</li>'
            + '</ul>'
            + '<div>This means that we need to match receipt info, in order to see what CTA is relevant.</div>'
            + '<div>We will test the receipt and registration info in an order.</div>'
            + '<div>As an example, we have this products list: ["ModelNr TV", "ModelNr Soundbar", "LineItem Batteries"], and a receipt with the following:</div><br/>'
            + '<ul>'
            + '<li>test receipt.receipt_items[n].item_match_converted</li>'
            + '<li>test receipt.receipt_items[n].item_match</li>'
            + '<li>test receipt.receipt_items[n].item</li>'
            + '<li>test receipt.receipt_items[n].imeinr</li>'
            + '<li>test receipt.receipt_items[n].modelnr</li>'
            + '<li>test receipt.receipt_items[n].serialnr</li>'
            + '<li>test receipt.receipt_items[n].key</li>'
            + '</ul>',
        },
        {
          label: 'Ignore periods from line items',
          model: 'receiptTermIgnoreDots',
          checkbox: true,
          popupInfo: '<div>Periods = "." will be ignored</div>'
          + '<div>If you have a line item = "product. 123" it will be read as "product 123"</div><br/>',
        },
        {
          label: 'Ignore spaces from line items',
          model: 'receiptTermIgnoreSpaces',
          checkbox: true,
          popupInfo: '<div>Spaces = " " will be ignored</div>'
          + '<div>If you have a line item = "product 123" it will be read as "product123"</div><br/>',
        },
        {
          label: 'Receipt similarity (80-100)',
          model: 'receiptSimilarity',
          popupInfo: '<div>80 to 100, an exact copy of a receipt will be 100 (%) similar, if this value is 90, that means we let people through who have less than 90 (%) similar receipt</div>',
        },
        {
          label: 'Automatically confirm receipt',
          model: 'receiptAutomaticallyConfirmed',
          checkbox: true,
          popupInfo: '<div>Automatically go to the next step if the receipt has all the correct info</div>',
        },
        {
          label: 'Receipt validation attempts',
          model: 'receiptValidationAttempts',
          popupInfo: '<div>How many times the user can try to validate the receipt</div>'
        },
        /*{
          label: 'Can Change Item?',
          model: 'receiptCanChangeItem',
          checkbox: true,
        },
        {
          label: 'Can Change Item Cost?',
          model: 'receiptCanChangeItemCost',
          checkbox: true,
        },
        {
          label: 'Can Change Store?',
          model: 'receiptCanChangeStore',
          checkbox: true,
        },
        {
          label: 'Can Change Date?',
          model: 'receiptCanChangeDate',
          checkbox: true,
        },*/
      ],
    },
    receiptAcceptedTypesGroup: {
      title: 'PV - Accepted Document types',
      columns: 3,
      fields: [
        {
          groupHeader: 'What types of documents do you accept?',
        },
        {
          label: 'Receipts',
          model: 'receiptAcceptTypeReceipt',
          checkbox: true,
        },
        {
          label: 'Payment confirmations',
          model: 'receiptAcceptTypePaymentConfirmation',
          checkbox: true,
        },
        {
          label: 'Invoices',
          model: 'receiptAcceptTypeInvoice',
          checkbox: true,
        },
        {
          label: 'Order confirmations',
          model: 'receiptAcceptTypeOrderConfirmation',
          checkbox: true,
        },
        {
          label: 'Agreements',
          model: 'receiptAcceptTypeAgreement',
          checkbox: true,
        },
        {
          label: 'Warranty certificates',
          model: 'receiptAcceptTypeWarrantyCertificate',
          checkbox: true,
        },
      ]
    },
    receiptRetailerGroup: {
      title: 'PV - Accepted Retailers',
      columns: 1,
      fields: [
        {
          label: 'Retailer Manager',
          model: 'receiptRetailerList',
          multichoice: true,
          routeName: 'AdminPVRetailers',
          entityType: 'PVRetailer',
        },
        /*{
          label: 'Receipt shop list (lowercase) (USE ACCEPTED RETAILERS INSTEAD)',
          model: 'receiptShopList',
          inputType: 'textarea',
        },*/
        {
          label: 'Receipt shop exclude list (lowercase)',
          model: 'receiptShopExcludeList',
          inputType: 'textarea',
        },
        {
          label: 'Default to scanned metadata, for Retailer',
          model: 'receiptRetailerInWholeString',
          checkbox: true,
          popupInfo: '<div>Default to receipt_metadata.content if PV cannot find the retailer</div><br/>',
        },
      ],
    },
    dateRangeGroup: {
      title: 'PV - Date',
      columns: 3,
      fields: [
        {
          label: 'Use date range',
          model: 'useReceiptDateRange',
          checkbox: true,
        }, 
        {
          label: 'Available from',
          model: 'localReceiptDateRangeFrom',
          date: true,
        },
        {
          label: 'Available to',
          model: 'localReceiptDateRangeTo',
          date: true,
        },
        {
          label: 'Default to scanned metadata, for Date on the receipt',
          model: 'receiptDateInWholeString',
          checkbox: true,
          popupInfo: '<div>Default to receipt_metadata.content if PV cannot find the Date of the receipt</div><br/>'
            + '<div>This means that the first date found on the receipt YYYY-MM-DD or YY-MM-DD will be used,</div>'
            + '<div>which of course could be the incorrect date, because sometimes there are several dates on a receipt</div>',
        },
        {
          label: 'Max days since receipt date',
          model: 'receiptDateMaxDays',
        },
      ],
    },
    registrationGroup: {
      title: 'Product Registration (PR) step',
      columns: 3,
      fields: [
        {
          label: 'Product Registration step',
          model: 'registrationStep',
          checkbox: true,
        },
        {
          label: 'PR validation attempts',
          model: 'registrationValidationAttempts',
          popupInfo: '<div>How many times the user can try to validate the silver plate</div>'
        },
        {
          label: 'Registrations terms multiple',
          model: 'registrationTermsMultiple',
          inputType: 'textarea',
          popupInfo: '<div>The format is: [{ "key": "first", "label": "", "serial": true, "serial_description": "", "imei": true, "imei_description": "", "method": "GOOGLE_IMEI_MAY_23", "modelnr": true, "modelnrs": ["modelNr1", "modelNr2"] }]</div><br/>'
            + '<div>The keys are:</div>'
            + '<ul>'
            + '<li>key: "The key should be the same in receipt_terms_multiple.key, so that they can be related.</li>'
            + '<li>label: "The label will be shown above the registration step.</li>'
            + '<li>serial: true/false</li>'
            + '<li>serial_description: "you can find the imei here or here..."</li>'
            + '<li>imei: true/false</li>'
            + '<li>imei_description: "you can find the imei here or here..."</li>'
            + '<li>terms: ["ZZ123AA","ZZ123AB"]</li>'
            // + '<li>regexp: /([A-Z]{2}[0-9]{3}[A-Z]{2})/</li>' not supported yet
            + '<li>method: GOOGLE_IMEI_MAY_23, PHILIPS_SERIAL, MIN_FIVE_CHARS, MIN_FIVE_NUMBERS, EXACTLY_FOURTEEN_CHARS, EXACTLY_FOURTEEN_NUMBERS, EXACTLY_FIFTEEN_CHARS, EXACTLY_FIFTEEN_NUMBERS, STIGA_ROBOT_MOWER_SERIAL</li>'
            + '<li>modelnr: true/false</li>'
            + '<li>modelnrs: ["A5000", "A500", "A3000", "A300"] <b style="color: red;">IMPORTANT</b>: use longer terms before the shorter ones, if they contain the same characters!!!</li>'
            + '<li>analyze_image: true/false, if true a uploader will appear and it will be mandatory to upload an image</li>'
            + '<li>analyze_image_mandatory: true/false, if true the image is mandatory and will determine the inputs, and disables the inputs for the consumer</li>'
            + '<li>analyze_image_button: "Upload image"</li>'
            + '</ul>',
        },
      ],
    },
    surveyGroup: {
      title: 'Survey step',
      columns: 3,
      fields: [
        {
          label: 'Survey step',
          model: 'surveyStep',
          checkbox: true,
        },
        {
          label: 'survey',
          model: 'survey',
          inputType: 'textarea',
        },
      ],
    },
    addressGroup: {
      title: 'Address step',
      columns: 3,
      fields: [
        {
          label: 'Address step',
          model: 'addressStep',
          checkbox: true,
        },
        {
          label: 'Address Products',
          model: 'addressProducts',
          inputType: 'textarea',
          popupInfo: '<div>The format is: { "uniqueProduct1": { "prize_type": "premium" }, "imeiNumber": { "prize_type": "medium" }, "lösgodis": {...} }</div><br/>'
            + '<div>The key "uniqueProduct1" comes from "Receipt step"=>"products", and if that product is on the receipt, then you will send the prize_type, to the address</div><br/>'
            + '<div>Important! prize_type should be the same as the limited prizes prize_type, and it should be the exact id that the <b>Delivery partner</b> wants</div>',
        },
        {
          label: 'Delivery Partner',
          model: 'addressDeliveryPartner',
          inputType: 'select',
          selectOptions: ['ÅJ', 'MODINO'],
        },
        {
          label: 'Automatically send product',
          model: 'addressDeliveryAuto',
          checkbox: true,
          popupInfo: '<div>If checked, address_products must be configured correctly, and then the products will be send every day, if the amount is enough to fill an EU pallet</div>',
        },
        {
          label: 'Automatically send products every MONDAY, if there are more than this number',
          model: 'addressDeliveryAutoAmount',
          popupInfo: '<div>This setting together with "Automatically send product" will enable send outs every morning.</div>'
            + '<div>The most efficient way is to fill an EU pallet, so insert the estimated number of products that will fill an EU pallet</div>'
            + '<div>If the number is 10, and we have 23 to send out the next day, then we will send 2 EU pallets (with 10 units on each) and wait with 3 units</div>',
        },
        {
          label: 'Ask for country',
          model: 'addressCountry',
          checkbox: true,
        },
        {
          label: 'Ask for state',
          model: 'addressState',
          checkbox: true,
        },
        {
          label: 'Use address fraud filter',
          model: 'addressFraudFilter',
          checkbox: true,
          popupInfo: '<div>Use the address fraud filter</div>'
            + '<div>We will check if any other receipt has the same name and city and flag them for potential fraud</div>'
            + '<div>We will check if any other receipt has the same postal_code and address and flag them for potential fraud</div>',
        },
      ],
    },
    paymentGroup: {
      title: 'Payment step',
      columns: 3,
      fields: [
        {
          label: 'Payment step',
          model: 'paymentStep',
          checkbox: true,
        },
        {
          label: 'Payment entity',
          model: 'paymentEntity',
          popupInfo: '<div>The entity that the consumer will buy</div>',
        },
        {
          label: 'Payment products',
          model: 'paymentProducts',
          inputType: 'textarea',
          popupInfo: '<div>The format is: { "uniqueProduct1": 100, "imeiNumber": 200, "lösgodis": 5 }</div><br/>'
            + '<div>The key "uniqueProduct1" comes from "Receipt step"=>"products", and if that product is on the receipt, then you will get 100 in payment</div>'
            + '<div>If all the above keys are present on the receipt then the payment amounts will be added: 100+200+5 = 305</div>',
        },
        {
          label: 'Payment amount (default if nothing in payment products is matched)',
          model: 'paymentAmount',
        },
        {
          label: 'Payment currency',
          model: 'paymentCurrency',
          inputType: 'select',
          selectOptions: currencies,
        },
        {
          label: 'Payment methods',
          model: 'paymentMethods',
          popupInfo: '<div>Insert the payment methods that you want to use</div><br/>'
            + '<div>example: card, phone, account => the order defines the order in the UI</div><br/>'
        },
      ],
    },
    reviewGroup: {
      title: 'Review step',
      columns: 3,
      fields: [
        {
          label: 'Review step',
          model: 'reviewStep',
          checkbox: true,
        },
        {
          label: 'Review Products',
          model: 'reviewProducts',
          inputType: 'textarea',
          popupInfo: '<div>The format is: { "uniqueProduct1": { "bazaarvoice": "id_bazaar", "testfreaks": "id_test", "feefo": "id_feefo", "attributes": "tv, dolby, 8k...", "media": "url..." }, "imeiNumber": {...}, "lösgodis": {...} }</div><br/>'
            + '<div>The key "uniqueProduct1" comes from "Receipt step"=>"products", and if that product is on the receipt, then you will review id1 in the current review partner</div>',
        },
        {
          label: 'Review partner, default if there was no retailer setting',
          model: 'reviewPartner',
          inputType: 'select',
          selectOptions: ['', 'bazaarvoice', 'testfreaks', 'feefo'],
          // 'ekomi', 'trustspot', 'reviews', 'yotpo', 'feefo', 'resellerratings', 'trustedsite', 'google', 'facebook'
        },
        {
          label: 'Review header',
          model: 'reviewHeader',
        },
        {
          label: 'Review moderation',
          model: 'reviewModeration',
          checkbox: true,
          popupInfo: '<div>If we should evaluate if the review is appropriate, before sending the review to the partner</div>',
        },
        {
          label: 'Consumer moderation attempts',
          model: 'reviewModerationAttempts',
          popupInfo: '<div>After X attempts, the consumer is blocked until the admin unlocks more attempts</div><br/>'
            + '<div>Each attempt will cost for us, and you can grant more attempts to one specific consumer later on</div>',
        },
        {
          label: 'A short list of attributes of the product (default if no attributes are found on object)',
          model: 'reviewModerationProductDescription',
          popupInfo: '<div>The format is: attribute1, attribute2, attribute3 ... etc</div><br/>'
            + '<div>example: tv, dolby, 8k, 55inch, backlit, led, wifi</div>',
        },
        {
          label: 'Appropriate Language threshold, 0 means no filter',
          model: 'reviewModerationAppropriateThreshold',
        },
        {
          label: 'Product relevance threshold, 0 means no filter',
          model: 'reviewModerationRelevanceThreshold',
        },
        {
          label: 'Readability threshold, 0 means no filter',
          model: 'reviewModerationReadabilityThreshold',
        },
        {
          label: 'Incentivized review',
          model: 'reviewIncentivized',
          checkbox: true,
          popupInfo: '<div>If the consumer get something for the review, or if it\'s optional</div>',
        }
        /*{
          label: 'Review Rating (stars)',
          model: 'reviewRating',
          checkbox: true,
        },
        {
          label: 'Review textarea',
          model: 'reviewTextarea',
          checkbox: true,
        },
        {
          label: 'Review delay, delay in days before review is shown',
          model: 'reviewDelay',
        },*/
      ],
    },
    cashbackGroup: {
      title: 'Cashback step',
      columns: 3,
      fields: [
        {
          label: 'Cashback step',
          model: 'cashbackStep',
          checkbox: true,
        },
        {
          label: 'Cashback products',
          model: 'cashbackProducts',
          inputType: 'textarea',
          popupInfo: '<div>The format is: { "uniqueProduct1": 100, "imeiNumber": 200, "lösgodis": 5 }</div><br/>'
            + '<div>The key "uniqueProduct1" comes from "Receipt step"=>"products", and if that product is on the receipt, then you will get 100 in cashback</div>'
            + '<div>If all the above keys are present on the receipt then the cashback amounts will be added: 100+200+5 = 305</div>',
        },
        {
          label: 'Cashback amount (default if nothing in cashback products is matched)',
          model: 'cashbackAmount',
        },
        {
          label: 'Cashback amount addition',
          model: 'cashbackAmountAddition',
          popupInfo: '<div>We will add this amount to each of the cashback products.</div>'
        },
        {
          label: 'Cashback amount addition date after',
          model: 'cashbackAmountAdditionDateAfter',
          date: true,
          popupInfo: '<div>We will add this amount to each of the cashback products.</div>'
            + '<div>It will be added to receipts after the date</div>',
        },
        {
          label: 'Cashback amount addition date before',
          model: 'cashbackAmountAdditionDateBefore',
          date: true,
          popupInfo: '<div>We will add this amount to each of the cashback products.</div>'
            + '<div>It will be added to receipts before the date</div>',
        },
        {
          label: 'Cashback currency',
          model: 'cashbackCurrency',
          inputType: 'select',
          selectOptions: currencies,
        },
        {
          label: 'Cashback payoutmethods ("card, phone, account") the order defines the order in the UI',
          model: 'cashbackPayoutmethods',
        },
        {
          label: 'Send receipt details to CDI at cta_done, (for buy & try returns)',
          model: 'cashbackManualPartner',
          checkbox: true,
        },
        {
          label: 'Cashback Done Email?',
          model: 'cashbackDoneEmail',
          checkbox: true,
          popupInfo: '<div>If checked, the consumer will get an email when the cashback is at their account</div>',
        },
        {
          label: 'Cashback Blocked Email?',
          model: 'cashbackBlockedEmail',
          checkbox: true,
          popupInfo: '<div>If checked, the consumer will get an email when the cashback is blocked</div>',
        },
        {
          label: 'Cashback Blocked Email subject',
          model: 'cashbackBlockedEmailSubject',
        },
        {
          label: 'Cashback Blocked Email template',
          model: 'cashbackBlockedEmailTemplate',
          inputType: 'textarea',
        },
        /*{
          label: 'cashback Delay, delay in days before cashback is paid out',
          model: 'cashbackDelay',
        },
        {
          label: 'cashback Total amount, the total amount of cashback that we will give to CDI',
          model: 'cashbackTotalAmount',
        },*/
      ],
    },
    ctaCodesGroup: {
      title: 'Limited prizes',
      columns: 3,
      fields: [
        {
          label: 'Limited prizes',
          model: 'ctaCodesBoolean',
          checkbox: true,
        },
        {
          label: 'Add list of prizes (only use one of these 3)',
          model: 'ctaCodes',
          inputType: 'textarea',
        },
        {
          label: 'Add prizes (X amount of codes)',
          model: 'ctaCodesAmount',
        },
        {
          label: 'Add list of prizes, with a type ',
          model: 'ctaCodesList',
          inputType: 'textarea',
          popupInfo: '<div>Use this format to add prizes, adding 10 premium prizes, adding 2 medium prizes:</div><br/>'
            + '<div>[{ "prize_type": "premium", "cost": 100, "amount": 10 }, { "prize_type": "medium", "cost": 50, "amount": 2 }, { "prize_type": "budget", "cost": 10, "amount": 2 }]</div>',
        },
        {
          label: 'Add prize inheritance (Inherit codes from another activation, insert id)',
          model: 'ctaCodesInheritance',
        },
      ],
    },
    ctaDoneGroup: {
      title: 'CTA done, last step',
      columns: 3,
      fields: [
        {
          label: 'Header',
          model: 'ctaDoneHeader',
        },
        {
          label: 'Show the cta code',
          model: 'ctaCodeVisible',
          checkbox: true,
          popupInfo: '<div>If the cta code should be shown in the last step</div>',
        },
        {
          label: 'Custom body',
          model: 'ctaDoneCustomMessage',
        },
        {
          label: 'Custom icon',
          model: 'ctaDoneCustomIcon',
          inputType: 'select',
          selectOptions: ['person', 'heart', 'festival', 'confetti', 'gift', 'info', 'shop', 'question'],
        },
        {
          label: 'Button description',
          model: 'ctaDoneButtonDescription',
        },
        {
          label: 'Button text',
          model: 'ctaDoneButton',
        },
        {
          label: 'Button url',
          model: 'ctaDoneUrl',
          popupInfo: '<div>This url will be opened when the button is clicked</div>'
            + '<div>You can use some variables in the url, use these if you need:</div>'
            + '<div>${name} => the name of the user</div>'
            + '<div>${ctacode} => the unique cta code</div>'
        },
        {
          label: '"Add another" button text',
          model: 'ctaDoneAddNewButton',
          popupInfo: '<div>This button is shown if you have recurring enabled</div>',
        },
      ],
    },
    termsGroup: {
      title: 'Terms',
      columns: 3,
      fields: [
        {
          label: 'Mandatory terms',
          model: 'termsMustAccept',
          checkbox: true,
        },
        {
          label: 'Term text',
          model: 'termsText',
          htmlText: true,
        },
        {
          label: 'Merchandise checkbox default',
          model: 'termsMerchandiseDefault',
          checkbox: true,
        },
        {
          label: 'Terms merchandise text',
          model: 'termsMerchandise',
          htmlText: true,
          popupInfo: '<div>Merchandise checkbox text, if there is no text here, then the checkbox will not appear</div>',
        },
      ],
    },
    popupGroup: {
      title: 'Popup Modal',
      columns: 2,
      fields: [
        {
          label: 'Popup modal version',
          model: 'popupModalVersion',
          popupInfo: '<div>Add a version of the popupmodal (ex: 1), then all consumers will have it popup 1 time, and it will not be shown again, until you set another verion</div>',
        },
        {
          label: 'Popup modal text',
          model: 'popupModalText',
          htmlText: true,
        },
      ],
    },
    scheduleGroup: {
      title: 'Scheduling',
      columns: 2,
      fields: [
        {
          label: 'Automatically publish on',
          model: 'localScheduledPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'Automatically unpublish on',
          model: 'localScheduledUnPublishAt',
          date: true,
          required: true,
        },
        {
          label: 'When unpublishing, can everyone who have started their journey finish the activation?',
          model: 'scheduledUnPublishConsumersCanFinish',
          checkbox: true,
        },
      ],
    },
    uploads: {
      title: 'Uploads',
      columns: 2,
      fields: [],
    },
    actionsGroup: {
      title: 'Actions',
      columns: 1,
      fields: [
        {
          label: 'Actions Manager',
          actionsManager: true,
        },
      ],
    },
  },

  PVChain: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'terms',
          model: 'terms',
          inputType: 'textarea',
          required: true,
        },
      ],
    },
    reviewGroup: {
      title: 'Review Partner',
      columns: 3,
      fields: [
        {
          label: 'Review partner',
          model: 'reviewPartner',
          inputType: 'select',
          selectOptions: ['', 'bazaarvoice', 'testfreaks', 'feefo'],
        },
      ],
    },
  },

  PVRetailer: {
    name: {
      title: 'Details',
      columns: 3,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'terms',
          model: 'terms',
          inputType: 'textarea',
          required: true,
        },
        /*{
          label: 'ignore_dots',
          model: 'ignoreDots',
          checkbox: true,
        },
        {
          label: 'ignore_spaces',
          model: 'ignoreSpaces',
          checkbox: true,
        },*/
      ],
    },
    reviewGroup: {
      title: 'Review Partner',
      columns: 3,
      fields: [
        {
          label: 'Review partner',
          model: 'reviewPartner',
          inputType: 'select',
          selectOptions: ['', 'bazaarvoice', 'testfreaks', 'feefo'],
        },
      ],
    },
  },

  PVStore: {
    name: {
      title: 'Details',
      columns: 2,
      fields: [
        {
          label: 'Name',
          model: 'name',
          required: true,
        },
        {
          label: 'Phone Nr',
          model: 'phoneNr',
        },
        {
          label: 'Secondary Phone Nrs',
          model: 'phoneNrSecondary',
          inputType: 'textarea',
        },
        {
          label: 'Address',
          model: 'address',
        },
        {
          label: 'House Nr',
          model: 'houseNr',
        },
        {
          label: 'House',
          model: 'house',
        },
        {
          label: 'Road',
          model: 'road',
        },
        {
          label: 'City',
          model: 'city',
        },
        {
          label: 'City District',
          model: 'cityDistrict',
        },
        {
          label: 'Suburb',
          model: 'suburb',
        },
        {
          label: 'Postal Code',
          model: 'postalCode',
        },
        {
          label: 'Country',
          model: 'country',
        },
        {
          label: 'Address Unsorted',
          model: 'addressUnsorted',
        },
        /*{
          model: 'phoneNrFormatted',
        },
        {
          model: 'addressFormatted',
        },
        {
          model: 'houseNrFormatted',
        },
        {
          model: 'houseFormatted',
        },
        {
          model: 'roadFormatted',
        },
        {
          model: 'cityFormatted',
        },
        {
          model: 'cityDistrictFormatted',
        },
        {
          model: 'postalCodeFormatted',
        },
        {
          model: 'countryFormatted',
        },
        {
          model: 'addressUnsortedFormatted',
        },*/
      ],
    },
  },

  PVPartnerAPI: {
    name: {
      title: 'Details',
      columns: 2,
      fields: [
        {
          label: 'Name',
          model: 'name',
        },
        {
          label: 'Info',
          model: 'info',
        },
      ],
    },
    secretGroup: {
      title: 'Secrets',
      columns: 2,
      fields: [
        {
          label: 'Url of the api',
          model: 'apiUrl',
        },
        /*{
          label: 'whitelisted methods of the api',
          model: 'apiMethod',
        },*/
        {
          label: 'Auth type of the API',
          model: 'apiAuth',
        },
        {
          label: 'API Key',
          model: 'apiKey',
        },
        {
          label: 'Api Secret',
          model: 'apiSecret',
        },
      ],
    },
  },

  Communication: {
    name: {
      title: 'Details',
      columns: 2,
      fields: [
        {
          label: 'Name',
          model: 'name',
        },
        {
          label: 'Info',
          model: 'info',
        },
      ],
    },
    contactGroup: {
      title: 'Contact',
      columns: 1,
      fields: [
        {
          label: 'Users',
          model: 'userCommunications',
          multichoice: true,
          routeName: 'AdminUsers',
          entityType: 'User',
          displayFields: ['name', 'email', 'phone_nr'],
        },
      ],
    },
    emailGroup: {
      title: 'Email',
      columns: 2,
      fields: [
        {
          label: 'Email Subject',
          model: 'emailSubject',
        },
        {
          label: 'Functional email?',
          model: 'emailFunctional',
          checkbox: true,
        },
      ],
    }
  }
};
